import type { NoContext } from '~/services/api/contracts/NoContext'
import { PartnerUserInvitationShowOrganizerQuerySchema } from '~/services/api/generated'

// InvitationLookupRequest::rules
export const PartnerUserInvitationShowOrganizer = (_context: NoContext = {}) =>
  PartnerUserInvitationShowOrganizerQuerySchema
